import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from "../../../vendor_core/core/src/server/data/ISpinData";
import { State } from "../../../vendor_core/core/src/states/State";
import Utils from '../../../vendor_core/core/src/utils/Utils';
import BBModel from '../model/BBModel';
import BBWildsMovements from '../utils/algorithm';


export default class BBParseMoveDataStateIco extends State {
    public enter(): void {
        super.enter();

        // let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        //     .getCurrentScene()
        //     .getSubView("ReelGroup") as BBReelGroup;

        // let wilds = reelGroup.searchWilds();

        // let lockedObj = null;
        // let movingObj = null;

        BBModel.cascadesOverlay = [];
        // let nextWilds = [];

        let currentGenIndex = SpinModel.cascadeIndex;
        // let currentGeneration: any = SpinModel.cascades[currentGenIndex];
        let currentGeneration: any = SpinModel.generations[currentGenIndex];

        // console.log(currentGeneration);
        // console.log(currentGenIndex);
        // console.log(BBModel.cascades);
        // console.log(SpinModel);

        // debugger

        if (currentGeneration) {
            const result = BBWildsMovements.calculateMoves(currentGeneration);
            const removedPaths = result.reduce((acc, data) => {
                if (data.dir === "left" || data.dir === "right") {
                    acc.push(data)
                }

                return acc
            }, []);

            if (removedPaths.length > 0) {

                // debugger

                const reduceReelAndRowIndexes = removedPaths.map(data => {
                    data.start.x -= 1;
                    data.start.y -= 1;
                    data.end.x -= 1;
                    data.end.y -= 1;

                    return data
                })

                const sortedData = this.sortResult(reduceReelAndRowIndexes)

                const lockedObj = this.generateLockObj(sortedData);
                const movingObj = this.generateMoveObj(sortedData);

                BBModel.cascadesOverlay.push(lockedObj);
                BBModel.cascadesOverlay.push(movingObj);

                // console.log(BBModel);
                // console.log(result);
                // debugger
            } else {
                BBModel.cascadesOverlay = [];
            }

        } else {
            BBModel.cascadesOverlay = [];
        }

        this.exit()
    }

    public sortResult = (data: any[]) => {
        const result = Utils.deepClone(data).sort((obj1, obj2) => {
            if (obj1.start.x < obj2.start.x) {
                return -1
            } else if (obj1.start.x > obj2.start.x) {
                return 1
            } else {
                if (obj1.start.y <= obj2.start.y) {
                    return -1
                } else {
                    return 1
                }
            }
        })

        return result
    }
    public generaEmptyMatrix = (): any[][] => {
        return [
            [null, null, null, null, null, null, null, null],
            [null, null, null, null, null, null, null, null],
            [null, null, null, null, null, null, null, null],
            [null, null, null, null, null, null, null, null],
            [null, null, null, null, null, null, null, null],
            [null, null, null, null, null, null, null, null],
            [null, null, null, null, null, null, null, null],
            [null, null, null, null, null, null, null, null],
        ]
    }

    public generateLockObj = (data: any[]) => {
        let lockMatrix = this.generaEmptyMatrix();

        data.forEach(coordinates => {
            lockMatrix[coordinates.start.x][coordinates.start.y] = 0;
        })

        let result = {
            type: OverlayType.Locked,
            symbolPosition: lockMatrix,
        };

        return result
    }
    public generateMoveObj = (data: any[]) => {
        const movableSymbolsMatrix = this.generaEmptyMatrix();
        const paths = [];
        data.forEach(coordinates => {
            movableSymbolsMatrix[coordinates.start.x][coordinates.start.y] = 0;
            paths.push({
                reel: coordinates.end.x,
                row: coordinates.end.y
            })
        })


        let result = {
            type: OverlayType.Moving,
            symbolPosition: movableSymbolsMatrix,
            path: paths
        }

        return result

    }
}

interface IWild {
    x: number,
    y: number
}
